import { render, staticRenderFns } from "./balance-inventory-by-branch.vue?vue&type=template&id=a50fd270&scoped=true&"
import script from "./balance-inventory-by-branch.vue?vue&type=script&lang=js&"
export * from "./balance-inventory-by-branch.vue?vue&type=script&lang=js&"
import style0 from "./balance-inventory-by-branch.vue?vue&type=style&index=0&id=a50fd270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50fd270",
  null
  
)

export default component.exports